"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentityProviderService = void 0;
const axios_1 = require("axios");
const abstract_service_1 = require("../shared/abstract-service");
class IdentityProviderService extends abstract_service_1.AbstractService {
    constructor(baseUrl, headerRetrievalFunction) {
        super(baseUrl, headerRetrievalFunction);
        this.userPath = '/user';
        this.authPath = '/v1/auth';
        this.mePath = '/v1/me';
        this.invPath = '/v1/invitations';
        this.orgPath = '/v1/organization';
        this.checksPath = '/v1/checks';
        this.invitedPath = '/invited';
        this.membersPath = '/members';
    }
    createUser(email, password, password_confirmation) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.post(`${this.baseUrl}${this.userPath}`, {
                email: email,
                password: password,
                password_confirmation: password_confirmation
            });
            if (response.status != 201) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    sendResetPasswordInstructions(email) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.post(`${this.baseUrl}${this.userPath}/password`, {
                user: {
                    email: email
                }
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    setNewPasswordByToken(resetPasswordToken, password, passwordConfirmation) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.patch(`${this.baseUrl}${this.userPath}/password`, {
                user: {
                    reset_password_token: resetPasswordToken,
                    password: password,
                    password_confirmation: passwordConfirmation
                }
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    confirmUser(authCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(`${this.baseUrl}${this.userPath}/confirmation?confirmation_token=${authCode}`);
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            localStorage.setItem('ivAccessToken', response.data.token);
        });
    }
    authUser(email, password) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.post(`${this.baseUrl}${this.authPath}`, {
                email: email,
                password: password
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            localStorage.setItem('ivAccessToken', response.data.token);
        });
    }
    authUserToOrg(orgId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(`${this.baseUrl}${this.authPath}/${orgId}`, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            localStorage.setItem('ivAccessToken', response.data.token);
        });
    }
    authUserMS(microsoftBearerToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.post(`${this.baseUrl}${this.authPath}/ms`, {
                microsoftBearerToken: microsoftBearerToken
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            localStorage.setItem('ivAccessToken', response.data.token);
        });
    }
    getUser() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(`${this.baseUrl}${this.mePath}/info`, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    updateUser(name, profile_pic, position, camera_disabled, mic_disabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const device_settings_to_request = camera_disabled != undefined && mic_disabled != undefined ? { camera_disabled: camera_disabled, mic_disabled: mic_disabled } : undefined;
            const response = yield axios_1.default.patch(`${this.baseUrl}${this.mePath}/update`, {
                fields: {
                    name: name,
                    profile_pic: profile_pic,
                    position: position,
                    device_settings: device_settings_to_request
                }
            }, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    videoDisplayedToUser() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.patch(`${this.baseUrl}${this.mePath}/update`, {
                fields: {
                    videoDisplayed: true
                }
            }, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    showUserJoinedOrgs() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(`${this.baseUrl}${this.mePath}/orgs`, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    userJoinOrg(orgId, role) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.patch(`${this.baseUrl}${this.mePath}/join-organization`, {
                orgId: orgId,
                role: role
            }, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            localStorage.setItem('ivAccessToken', response.data.token);
        });
    }
    userQuitOrg(orgId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.patch(`${this.baseUrl}${this.mePath}/quit-organization`, {
                orgId: orgId
            }, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    showUserPendingInvitations() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(`${this.baseUrl}${this.mePath}/pending-invitations`, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    createInvitation(note, areaId, campusId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.post(`${this.baseUrl}${this.invPath}`, {
                note: note,
                areaId: areaId,
                campusId: campusId
            }, {
                headers: this.getHeaders()
            });
            if (response.status != 201) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    showUserInvitationsList() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(`${this.baseUrl}${this.invPath}`, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    showInvitation(invitationId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(`${this.baseUrl}${this.invPath}/${invitationId}`);
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    deleteInvitation(invitationId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.delete(`${this.baseUrl}${this.invPath}/${invitationId}`, {
                headers: this.getHeaders()
            });
            if (response.status != 204) {
                throw new Error(response.statusText);
            }
            return response.statusText;
        });
    }
    authVisitor(email, name, invitationId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.post(`${this.baseUrl}${this.authPath}/invitation/${invitationId}`, {
                email: email,
                name: name
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            localStorage.setItem('ivAccessToken', response.data.token);
        });
    }
    confirmVisitor(areaId, campusId, visitorId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.post(`${this.baseUrl}/v1/confirm/${visitorId}`, {
                areaId: areaId,
                campusId: campusId
            }, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            if (typeof response.data.token == 'string')
                return response.data.token;
        });
    }
    useConfirmationToken(confirmationToken) {
        const currentToken = localStorage.getItem('ivAccessToken');
        if (!currentToken)
            return false;
        const accessToken = currentToken === null || currentToken === void 0 ? void 0 : currentToken.split(':')[0];
        const nextToken = accessToken + ':' + confirmationToken;
        localStorage.setItem('ivAccessToken', nextToken);
        return true;
    }
    createOrg(orgName, orgSize, locationsCount) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.post(`${this.baseUrl}${this.orgPath}`, {
                fields: {
                    orgName: orgName,
                    orgSize: orgSize,
                    locationsCount: locationsCount
                }
            }, {
                headers: this.getHeaders()
            });
            if (response.status != 201) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    updateOrg(orgName, orgLogo, orgColors, orgSize, locationsCount) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.patch(`${this.baseUrl}${this.orgPath}`, {
                fields: {
                    orgName: orgName,
                    orgLogo: orgLogo,
                    orgColors: orgColors,
                    orgSize: orgSize,
                    locationsCount: locationsCount
                }
            }, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    showOrg() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(`${this.baseUrl}${this.orgPath}`, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    getOrgBranding(orgId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(`${this.baseUrl}${this.orgPath}/${orgId}/branding`);
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    orgLimitReached() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(`${this.baseUrl}${this.orgPath}/limit-reached`, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    showOrgInvited() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(`${this.baseUrl}${this.orgPath}${this.invitedPath}`, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    newInvited(email, role) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.post(`${this.baseUrl}${this.orgPath}${this.invitedPath}`, {
                email: email,
                role: role
            }, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    deleteInvited(email) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.patch(`${this.baseUrl}${this.orgPath}${this.invitedPath}`, {
                email: email
            }, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    showMembers() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(`${this.baseUrl}${this.orgPath}${this.membersPath}`, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    changeMemberRole(newRole, userId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.patch(`${this.baseUrl}${this.orgPath}${this.membersPath}/${userId}`, {
                newRole: newRole
            }, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    showMemberProfile(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(`${this.baseUrl}${this.orgPath}${this.membersPath}/${userId}`, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    removeMember(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.delete(`${this.baseUrl}${this.orgPath}${this.membersPath}/${userId}`, {
                headers: this.getHeaders()
            });
            if (response.status != 204) {
                throw new Error(response.statusText);
            }
        });
    }
    checkSetupCompleted() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(`${this.baseUrl}${this.checksPath}/setup_completed`, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    transferOwnership(new_owner_id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.patch(`${this.baseUrl}${this.orgPath}/transfer-ownership`, {
                new_owner_id: new_owner_id
            }, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
}
exports.IdentityProviderService = IdentityProviderService;
